import classification from "../../services/classification"

export default {
    namespaced: true,
    state: {
        classification: {
            currentLevel: undefined,
            otherRequirements: []
        },
    },
    mutations: {
        STORE_CLASSIFICATION(state, classification) {
            state.classification = classification
        }
    },
    actions: {
        REFRESH: async (context) => {
            const classificationFirstList = await classification
                .getClassification()
                .then(response => response.success ? response.data : {})
                .catch(
                    () => []
                )
            if (classificationFirstList.otherRequirements && classificationFirstList.otherRequirements.length) {
                classificationFirstList.otherRequirements.forEach(async (requirement) => {
                    const conditions = []
                    const level = requirement.level
                    if (requirement.conditions.length) {
                        requirement.conditions.forEach(item => {
                            const condition = classification.getDetailCondition(level, item.nthCondition)
                            conditions.push(condition)
                        })

                        await Promise.all(conditions).then(response => {
                            if (response.length) {
                                response.forEach((element, index) => {
                                    if (element.success && element.count) {
                                        const content_holder = element.advClassification[0].secondaryText.replace(/<(?:.|\n)*?>/gm, '')
                                        requirement.conditions[index].id = element.advClassification[0].id
                                        requirement.conditions[index].mainText = element.advClassification[0].mainText
                                        requirement.conditions[index].secondaryText = content_holder
                                    }
                                })
                            }
                        }).catch(() => { })
                            .finally(() => {
                                requirement.conditions = requirement.conditions.filter(condition => condition.id)
                                context.commit('STORE_CLASSIFICATION', classificationFirstList)
                            })
                    }
                })
            } else {
                context.commit('STORE_CLASSIFICATION', classificationFirstList)
            }

            // await Promise.all(
            //     classificationFirstList.otherRequirements
            //         .map(
            //             async e => {
            //                 e.conditions.map(
            //                     async (item, index) => {
            //                         item = await classification
            //                             .getDetailCondition(e.level, item.nthCondition)
            //                             .then(response => {
            //                                 if (response.count) {
            //                                     response.advClassification[0].isFulfilled = item.isFulfilled
            //                                     const content_holder = response.advClassification[0].secondaryText.replace(/<(?:.|\n)*?>/gm, '');
            //                                     response.advClassification[0].secondaryText = content_holder
            //                                     e.conditions[index] = response.advClassification[0]
            //                                     return response.advClassification[0]
            //                                 }
            //                             })
            //                             .catch(
            //                                 () => undefined
            //                             )
            //                         return item
            //                     }
            //                 )
            //                 return e
            //             }
            //         )
            // ).then(_ => {
            //     setTimeout(() => {
            //         context.commit('STORE_CLASSIFICATION', classificationFirstList)
            //     }, 300);
            // })
        }
    },
    getters: {
        classification: state => state.classification,
    }
}
